
export default {
  props: {
    block: {
      type: Object,
      default: () => ({}),
    },
    sharedPlayers: {
      type: Array,
      default: null,
    },
    sharedFormation: {
      type: String,
      default: null,
    },
    selectable: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      formations: [
        `4-4-2`,
        `4-1-2-1-2`,
        `4-3-3`,
        `4-5-1`,
        `4-4-1-1`,
        `4-1-4-1`,
        `4-2-3-1`,
        `4-3-2-1`,
        `5-3-2`,
        `5-4-1`,
        `3-5-2`,
        `3-4-3`,
        `4-2-2-2`,
        `3-5-1-1`,
        `3-4-2-1`,
        `3-4-1-2`,
        `3-1-4-2`,
        `3-1-2-1-3`,
        `4-1-3-2`,
        `4-2-4`,
        `4-3-1-2`,
        `3-2-4-1`,
        `3-3-3-1`,
      ],
      selectedFormation: `4-4-2`,
      squads: [],
      squad: null,
      reset: false,
      confirm: false,
      lineupImage: null, // Base64 Image
      lineupComplete: false, // Whether confirm button is enabled
      shareUrl: ``,
      copied: false,
      loading: false,
      showShare: false,
    };
  },
  computed: {
    sortedSquad () {
      if (this.squad) {
        const squad = this.squad.playerSquads;
        return [...squad].sort((a, b) => parseInt(a.squadNumber) - parseInt(b.squadNumber));
      } return [];
    },
    twitterShareUrl () {
      let url = `http://twitter.com/intent/tweet?`;
      url += `text=${encodeURIComponent(this.settings.twitter_text)}`;
      url += `&url=${encodeURIComponent(this.shareUrl)}`;

      const hashtags = this.settings.twitter_hashtags;

      if (hashtags) {
        const hashtagString = hashtags.map(hash => encodeURIComponent(hash.hashtag)).join(`,`);
        url += `&hashtags=${hashtagString}`;
      }

      return url;
    },
    team () {
      return this.block?.team_override?.team.length ? this.block.team_override.team[0] : this.getDefault(`team`);
    },
    season () {
      return this.getDefault(`season`);
    },
    settings () {
      return this.siteSettings.lineup_predictor;
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.getSquad();
      if (this.sharedFormation) {
        this.selectedFormation = this.sharedFormation;
      }
    });
  },
  methods: {
    async getSquad () {
      this.loading = true;

      const params = {
        include: `team,playerSquads.player.images`,
        filter: {
          "teamId": this.team.id,
          "seasonId": this.season.id,
        },
        filterIncludes: {
          "playerSquads.player.images.description": `headshot`,
        },
      };

      const request = await this.$getStats(`squad`, params);
      if (request !== null) {
        this.squad = request.data[0];
      }
      this.loading = false;
    },
    share () {
      // Generate URL
    },
    confirmTeam () {
      this.confirm = true;
      this.showShare = true;
    },
  },
};
